import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'PetCore',
  brandName: 'PetCore',
  description: 'Sistema de agendamento para médicos veterinários',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Clínica veterinária moderna',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Veterinário examinando animal',
  },
  testimonials: [
    {
      name: 'Dr.ª Matilde Alves',
      role: 'Médica Veterinária',
      text: 'O PetCore simplificou a marcação de consultas e vacinas. Os donos dos animais agradecem a facilidade.',
      image: testimonial1,
    },
    {
      name: 'Bolinha & Dono',
      role: 'Cliente',
      text: 'Marcar a consulta anual do Bolinha foi super rápido. Recebi o lembrete e não me esqueci!',
      image: testimonial2,
    },
    {
      name: 'Hospital Veterinário Central',
      role: 'Gestão',
      text: 'Uma plataforma essencial para a gestão diária de uma clínica movimentada. Recomendo.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'veterinário',
    professionals: 'veterinários',
    business: 'clínica',
    businesses: 'clínicas',
    service: 'consulta',
    services: 'consultas',
    client: 'tutor',
    clients: 'tutores',
    appointment: 'consulta',
    appointments: 'consultas',
  },
  homepage: {
    hero: {
      badge: 'Solução Veterinária',
      title: 'Cuide melhor dos seus pacientes com PetCore',
      description: 'Otimize sua clínica veterinária e ofereça o melhor atendimento aos animais e seus tutores.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Sem cartão de crédito', 'Configuração em 5 minutos'],
    },
    statistics: [
      { value: '90+', label: 'Clínicas' },
      { value: '15k+', label: 'Consultas' },
      { value: '98%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Interrupções Durante Atendimentos',
        description: 'Atender chamadas durante consultas veterinárias causa stress aos animais e compromete o diagnóstico.',
        icon: 'PhoneCall',
        quote: {
          text: 'Com o PetCore, eliminámos as interrupções por telefone e os animais ficam mais calmos durante o exame',
          author: 'Dr. Pedro Santos',
          business: 'Clínica Animal Vida',
        },
      },
      {
        title: 'Esquecimento de Vacinas',
        description: 'Tutores esquecem-se das datas de vacinação, comprometendo a saúde dos animais.',
        icon: 'Calendar',
        stats: [
          { label: 'Atraso médio nas vacinas:', value: '45 dias' },
          { label: 'Tutores que esquecem:', value: '60%' },
        ],
      },
      {
        title: 'Ausências de Última Hora',
        description: 'Faltas sem aviso deixam horários vagos que poderiam atender emergências ou outros animais.',
        icon: 'Users',
        quote: {
          text: 'Reduzimos as ausências em 80% com lembretes automáticos. Agora conseguimos atender mais animais',
          author: 'Dr.ª Carla Nunes',
          business: 'Hospital Veterinário São Francisco',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'PetCore: O melhor cuidado animal',
      description: 'Tecnologia pensada para clínicas veterinárias que querem oferecer o melhor atendimento.',
      features: [
        {
          title: 'Agendamento 24/7',
          description: 'Tutores marcam consultas, vacinas e check-ups a qualquer momento.',
        },
        {
          title: 'Histórico Clínico',
          description: 'Registo completo de cada animal: vacinas, consultas e tratamentos.',
        },
        {
          title: 'Lembretes de Vacinação',
          description: 'Notificações automáticas para manter o calendário vacinal em dia.',
        },
      ],
    },
    testimonials: {
      title: 'O que os veterinários dizem',
      description: 'Profissionais que confiam no PetCore para cuidar melhor dos animais.',
    },
    finalCta: {
      title: 'Pronto para cuidar melhor dos animais?',
      description: 'Junte-se a veterinários que já otimizaram sua clínica com o PetCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Falar com Especialista',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de veterinário',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
